import Image from "next/image";
import { Typography } from "../ui/typography";

/** Empty stay-window state from HotelDetails reserved frame (Figma 7237:38798). */
export function PdpReservedEmpty() {
  return (
    <div className="flex flex-col items-center justify-center gap-6 py-10 text-center">
      <div className="relative size-[118px] overflow-clip">
        <Image
          src="/images/icons/pdp-reserved-calendar.png"
          alt=""
          width={153}
          height={162}
          className="size-full object-contain"
        />
      </div>
      <div className="space-y-2">
        <Typography variant="bodySMedium">
          این اقامتگاه در این تاریخ رزرو شده است!
        </Typography>
        <Typography variant="bodySRegular" color="black300">
          لطفاً تاریخ دیگری انتخاب کنید.
        </Typography>
      </div>
    </div>
  );
}
